import { Route } from '@angular/router';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { InitialDataResolver } from 'app/app.resolvers';
import { AuthCallbackComponent } from 'app/modules/auth/call-back/app-call-back';

// @formatter:off
// tslint:disable:max-line-length
export const appRoutes: Route[] = [
    // Redirect empty path to '/example'
    { path: '', pathMatch: 'full', redirectTo: 'certification' },

    // Redirect signed in user to the '/example'
    //
    // After the user signs in, the sign in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    {
        path: 'signed-in-redirect',
        pathMatch: 'full',
        redirectTo: 'certification',
    },

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'confirmation-required',
                loadChildren: () =>
                    import(
                        'app/modules/auth/confirmation-required/confirmation-required.module'
                    ).then((m) => m.AuthConfirmationRequiredModule),
            },
            {
                path: 'forgot-password',
                loadChildren: () =>
                    import(
                        'app/modules/auth/forgot-password/forgot-password.module'
                    ).then((m) => m.AuthForgotPasswordModule),
            },
            {
                path: 'reset-password',
                loadChildren: () =>
                    import(
                        'app/modules/auth/reset-password/reset-password.module'
                    ).then((m) => m.AuthResetPasswordModule),
            },
            {
                path: 'sign-in',
                loadChildren: () =>
                    import('app/modules/auth/sign-in/sign-in.module').then(
                        (m) => m.AuthSignInModule,
                    ),
            },
            {
                path: 'sign-up',
                loadChildren: () =>
                    import('app/modules/auth/sign-up/sign-up.module').then(
                        (m) => m.AuthSignUpModule,
                    ),
            },
            {
                path: 'public',
                loadChildren: () =>
                    import('app/modules/public/public.module').then(
                        (m) => m.PublicModule,
                    ),
            },
        ],
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            // layout: 'empty'
        },
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: 'sign-out',
                loadChildren: () =>
                    import('app/modules/auth/sign-out/sign-out.module').then(
                        (m) => m.AuthSignOutModule,
                    ),
            },
            {
                path: 'unlock-session',
                loadChildren: () =>
                    import(
                        'app/modules/auth/unlock-session/unlock-session.module'
                    ).then((m) => m.AuthUnlockSessionModule),
            },
            {
                path: 'members',
                loadChildren: () =>
                    import('app/modules/members/members.module').then(
                        (m) => m.MembersModule,
                    ),
            },
            {
                path: 'chapters',
                loadChildren: () =>
                    import('app/modules/chapters/chapters.module').then(
                        (m) => m.ChaptersModule,
                    ),
            },
            {
                path: 'committee',
                loadChildren: () =>
                    import('app/modules/committee/committee.module').then(
                        (m) => m.CommitteeModule,
                    ),
            },
            {
                path: 'reports',
                loadChildren: () =>
                    import('app/modules/reports/reports.module').then(
                        (m) => m.ReportsModule,
                    ),
            },
            {
                path: 'certification',
                loadChildren: () =>
                    import(
                        'app/modules/certification/certification.module'
                    ).then((m) => m.CertificationModule),
            },
            {
                path: 'schools',
                loadChildren: () =>
                    import('app/modules/schools/schools.module').then(
                        (m) => m.SchoolsModule,
                    ),
            },
            {
                path: 'classes',
                loadChildren: () =>
                    import('app/modules/classes/classes.module').then(
                        (m) => m.ClassesModule,
                    ),
            },
            {
                path: 'reports-certificate',
                loadChildren: () =>
                    import(
                        'app/modules/reports-certificate/reports-certificate.module'
                    ).then((m) => m.ReportsCertificateModule),
            },
            {
                path: 'maintenance',
                loadChildren: () =>
                    import('app/modules/maintenance/maintenance.module').then(
                        (m) => m.MaintenanceModule,
                    ),
            },
        ],
    },

    // Landing routes
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'auth-callback',
                component: AuthCallbackComponent,
            },
            {
                path: 'home',
                loadChildren: () =>
                    import('app/modules/landing/home/home.module').then(
                        (m) => m.LandingHomeModule,
                    ),
            },
        ],
    },

    // Admin routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            // {path: 'example', loadChildren: () => import('app/modules/admin/example/example.module').then(m => m.ExampleModule)},
        ],
    },
];
